import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import Wrapper from "../../components/Wrapper";

import { getDiscover } from "./api";

export default function Discover() {
  const [data, setdata] = useState([]);
  const [page, setpage] = useState(0);
  const [published, setpublished] = useState(false);
  useEffect(() => {
    const getData = async () => {
      const response = await getDiscover(page, published);
      setdata(response);
    };
    getData();
  }, []);

  console.log(data);
  return (
    <Wrapper>
      <label style={{ display: "inline-block" }} htmlFor="published">
        show published
        </label>
      <input
        type="checkbox"
        className="field"
        name="published"
        placeholder="show published"
        value={published}
        defaultChecked={published}
        onChange={async () => {
          const response = await getDiscover(0, !published);
          setdata(response);
          setpage(1);
          setpublished(!published);
        }}
        style={{ display: "inline-block", width: "unset" }}
      />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          columnGap: "16px",
          rowGap: "16px",
        }}
      >
        {data &&
          data.length > 0 &&
          data.map((d) => {
            return (
              <Link
                to={{
                  pathname: `/discover/${d.id}`,
                  state: d,
                }}
                key={d.id}
              >
                {/* <div
                  style={{
                    backgroundImage: `url(${d.bannerImage})`,
                    height: "60px",
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    borderRadius: "16px",
                    backgroundRepeat: "no-repeat",
                  }}
                /> */}
                <div>{d.title} ({d.store})</div>
                <div>{d.published ? "Published" : "Un-published"}</div>
                <div>{d.order ? d.order : null}</div>
              </Link>
            );
          })}
      </div>
      <div style={{ display: "flex" }}>
        <button
          onClick={async () => {
            const response = await getDiscover(page - 1, published);
            setdata(response);
            setpage(page - 1);
          }}
        >
          Prev
        </button>
        <button
          onClick={async () => {
            const response = await getDiscover(page + 1, published);
            setdata(response);
            setpage(page + 1);
          }}
        >
          Next
        </button>
      </div>
    </Wrapper>
  );
}
